import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { SortingBy } from '../styles';
import {
  Behavior,
  FontEmphasis,
  TitleSmallText,
} from '@prisjakt/ui/text/variants';

type SortingByTextProps = {
  mobile: boolean;
};

export const SortingByText = ({ mobile }: SortingByTextProps) => {
  const { t } = useAppContext();
  return (
    <SortingBy $mobile={mobile}>
      <TitleSmallText
        flex={false}
        emphasis={FontEmphasis.LOW}
        behavior={Behavior.Oneline}
      >
        {t('product', 'sorting.sorted-by-cheapest-price')}
      </TitleSmallText>
    </SortingBy>
  );
};
